import { Theme, alpha, styled } from '@material-ui/core';

export const IndicatorsContainer = styled('div')<Theme, { leftMargin?: number }>(
  ({ theme, leftMargin = 0 }) => ({
    position: 'relative',
    right: leftMargin,
    top: 15,
    float: 'right',
    '& .hidden': {
      display: 'none',
    },
    '& .on-exercises': {
      zIndex: -1,
    },
    '&.exercises': {
      right: 0,
      top: '0',
    },
    '& .content': {
      border: `1px solid ${theme.config.appbarColors.borderColor}`,
      backgroundColor: theme.palette.background.paper,
      zIndex: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(1),
      gap: theme.spacing(1),
      width: '36px',
      height: '72px',
      marginRight: '-66px',
      borderBottomRightRadius: '8px',
      borderTopRightRadius: '8px',
      borderLeft: `1px solid ${theme.config.appbarColors.borderColor}`,
      cursor: 'pointer',
      '&.on-exercises': {
        marginRight: -36,
        borderLeft: 'none',
        height: '5rem',
      },
      '&.expanded': {
        height: 'auto',
      },
      '&.active': {
        borderColor: '#C65924',
        backgroundColor: theme.palette.primary.main,
        borderLeftColor: '#C65924',
        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
        },
      },
      '&.selected': {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.white,
        color: theme.palette.primary.main,
        borderLeftColor: theme.palette.primary.main,
        '& svg': {
          color: theme.palette.primary.main,
        },
        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
        },
      },
      '&.exercises': {
        height: '5rem',
      },
      '&.exercises-expanded': {
        height: '64px',
      },
      '&:hover': {
        borderColor: alpha(theme.palette.common.black, 0.2),
        '&.selected': {
          '& svg': {
            color: theme.palette.white,
          },
        },
      },
    },
  })
);

export const Counter = styled('button')<Theme>(({ theme }) => ({
  color: theme.palette.common.white,
  margin: 0,
  outline: 'none',
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
}));
